import select from './directives/select';

export default angular.module('edge.platform.widgets.select', []).directive('gwPlSelect', select);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/select/module.js
// module id = 1150
// module chunks = 0